import {Component, ContentChild, ElementRef, HostBinding, OnInit} from '@angular/core';

@Component({
  selector: 'cmp-cards',
  template: `<ng-content></ng-content>
`,
  styles: [``]
})
export class CardsComponent implements OnInit {

  @HostBinding('class') classes = 'card blv-frw-card';

  constructor() {
  }

  ngOnInit() {
  }

}
